import moment from 'moment'

export const Treatment = {
    id: '',
    name: '',
    price: 0,
    rawMaterialPrice: 0,
    remarks: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}